import { useEffect, useState } from "react";
import { CreditCard } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import CheckoutShell from "./CheckoutShell";


const CheckoutReadyPage = () => {
  const [checkout, setCheckout] = useState(null);
  const [error, setError] = useState("");
  const [opening, setOpening] = useState(false);

  useEffect(() => {
    api.get("/checkout/ready")
      .then((response) => setCheckout(response.data))
      .catch((requestError) => {
        setError(requestError.response?.data?.detail || "Checkout could not be prepared.");
      });
  }, []);

  const launchCheckout = () => {
    if (!checkout || opening) return;
    setOpening(true);
    if (window.Tebex?.checkout) {
      window.Tebex.checkout.init({
        ident: checkout.ident,
        theme: "dark",
        colors: [
          { name: "primary", color: "#0ea5e9" },
          { name: "secondary", color: "#22d3ee" },
        ],
      });
      window.Tebex.checkout.launch();
      setOpening(false);
      return;
    }
    window.location.assign(checkout.checkout_url);
  };

  return (
    <CheckoutShell title={error ? "Checkout unavailable" : "Ready for secure payment"}>
      {error ? (
        <p className="text-red-300">{error} Start again from the product page.</p>
      ) : checkout ? (
        <>
          <p>FiveM and Discord are connected. Tebex will now handle the payment securely.</p>
          <p className="mt-2 text-xs text-slate-500">AeroCore never receives or stores your card details.</p>
          <Button
            type="button"
            onClick={launchCheckout}
            disabled={opening}
            className="mt-7 bg-primary px-7 py-6 font-bold uppercase tracking-wider text-primary-foreground"
          >
            <CreditCard className="mr-2 h-5 w-5" />
            {opening ? "Opening…" : "Open Tebex checkout"}
          </Button>
        </>
      ) : (
        <div className="loading-spinner mx-auto h-7 w-7" />
      )}
    </CheckoutShell>
  );
};

export default CheckoutReadyPage;
